// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const BannerContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  background: #e6f4f1;
  color: #2b3038;
  padding: 24px 48px;
  border-radius: 30px;
  display: grid;
  grid-template-areas: "stack";
  position: relative;
  overflow: hidden;
  min-height: 158px;
`;

export const Slide = styled.div<{$active: boolean}>`
  grid-area: stack;
  width: 100%;
  opacity: ${p => (p.$active ? 1 : 0)};
  pointer-events: ${p => (p.$active ? 'auto' : 'none')};
  z-index: ${p => (p.$active ? 1 : 0)};
  transition: opacity 0.4s ease;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 1;
  max-width: 650px;
`;

export const FeaturedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  max-width: 400px;
  max-height: 110px;
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  flex-shrink: 0;
  height: 100%;
`;

export const Title = styled.h3`
  font-family: "Source Sans 3", sans-serif;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
  margin: 0;
  color: #1a1d24;
  text-transform: uppercase;
  max-width: 100%;

  /* Line clamping */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ReadMoreButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 24px;
  background: transparent;
  color: #1a1d24;
  border: 1.5px solid #1a1d24;
  border-radius: 4px;
  font-family: "Source Sans 3", sans-serif;
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  text-transform: uppercase;
  width: fit-content;
  transition: all 0.2s ease;
  line-height: 1;
  white-space: nowrap;

  &:hover {
    background: #1a1d24;
    color: #ffffff;
    text-decoration: none;
  }
`;

export const DotsContainer = styled.div`
  display: flex;
  gap: 12px;
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
  justify-content: center;
`;

export const Dot = styled.button<{$active?: boolean}>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${p => (p.$active ? '#1a1d24' : 'rgba(26, 29, 36, 0.2)')};
  border: none;
  padding: 0;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${p => (p.$active ? '#1a1d24' : 'rgba(26, 29, 36, 0.5)')};
  }
`;
